import { first, get, isEmpty } from 'lodash/fp';

const useGraphQLErrorExtractor = () => {
  const extractError = (error) => {
    const networkError = get('networkError', error);
    const graphQLErrors = get('graphQLErrors', error);
    if (networkError) {
      return networkError.message;
    }
    if (!isEmpty(graphQLErrors)) {
      return first(graphQLErrors).message;
    }
    return null;
  };
  return { extractError };
};

export default useGraphQLErrorExtractor;
